import { ContextRegistry, PathMetadata } from "./types";

let globalContextRegistry: ContextRegistry = {};

export const getContextData = (namespace: string): PathMetadata[] => {
    return globalContextRegistry[namespace] || [];
};

export const registerContextData = (namespace: string, data: PathMetadata[]): void => {
    globalContextRegistry[namespace] = data;
};

export const unregisterContextData = (namespace: string): void => {
    delete globalContextRegistry[namespace];
};

export const getGlobalContext = () => {
    return globalContextRegistry;
};

export const extractPaths = (obj: unknown, prefix = ""): PathMetadata[] => {
    if (!obj || typeof obj !== "object") return [];

    const result: PathMetadata[] = [];

    const processObject = (object: unknown, currentPrefix: string) => {
        if (!object || typeof object !== "object") return;

        Object.keys(object).forEach((key) => {
            const value = (object as Record<string, unknown>)[key];
            const fullPath = currentPrefix ? `${currentPrefix}.${key}` : key;
            const isArray = Array.isArray(value);

            result.push({ path: fullPath, isArray });

            if (isArray) {
                if (value.length > 0 && typeof value[0] === "object" && value[0] !== null) {
                    processObject(value[0], fullPath);
                }
            } else if (typeof value === "object" && value !== null) {
                processObject(value, fullPath);
            }
        });
    };

    processObject(obj, prefix);

    return result.sort((a, b) => a.path.localeCompare(b.path));
};
